<template>
  <v-card v-if="formDialog">
    <v-toolbar dark color="primary" tabs>
      <v-btn v-if="!noCloseButton" icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="!noTitle">{{ $t(title) }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- <v-btn dark flat @click="save">{{$t('Save')}}</v-btn> -->
      </v-toolbar-items>

      <v-tabs slot="extension" v-model="tab" dark color="primary" align-with-title>
        <v-tabs-slider color="secondary"></v-tabs-slider>

        <v-tab v-if="showDataTab">{{ $t('Datos identificativos') }}</v-tab>
        <v-tab v-if="showAddressTab">{{ $t('Domicilios') }}</v-tab>
        <v-tab v-if="showBankTab">{{ $t('Bancos') }}</v-tab>
        <v-tab v-if="showJuridicTab">{{ $t('Datos Jurídicos') }}</v-tab>
        <v-tab
          v-if="showContractDataTab && config.customerContract && config.customerContract.form"
        >
          {{ $t('Información contractual') }}
        </v-tab>
        <v-tab v-if="showFiscalObligationsTab">{{ $t('Obligaciones Fiscales') }}</v-tab>
        <v-tab v-if="showUsersTab">{{ $t('Usuarios') }}</v-tab>
        <v-tab v-if="showAdditionalDataTab">{{ $t('Información adicional') }}</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <!-- Datos identificativos -->
      <v-tab-item v-if="showDataTab">
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.identification_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
      </v-tab-item>

      <!-- Domicilios -->
      <v-tab-item v-if="showAddressTab">
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.address_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
      </v-tab-item>

      <!-- Bancos -->
      <v-tab-item v-if="showBankTab">
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.bank_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
      </v-tab-item>

      <!-- Datos Jurídicos -->
      <v-tab-item v-if="showJuridicTab">
        <aru-auto-form
          v-model="formData"
          :form-configuration="config.juridic_form"
          :submit-button="false"
          :dismiss-button="false"
        ></aru-auto-form>
        <!-- <customer-fiscal-data-form></customer-fiscal-data-form> -->
      </v-tab-item>

      <!-- Información contractual -->
      <v-tab-item
        v-if="showContractDataTab && config.customerContract && config.customerContract.form"
      >
        <aru-auto-form
          v-model="contractData"
          :form-configuration="config.customerContract.form"
          :submit-button="true"
          :submit-text="$t('Guardar')"
          :dismiss-button="true"
          :dismiss-text="$t('Cerrar')"
          @submit="submitContract"
          @dismiss="close"
        ></aru-auto-form>
      </v-tab-item>

      <!-- Obligaciones fiscales -->
      <v-tab-item v-if="showFiscalObligationsTab">
        <fiscal-obligation-table :clavedat="this.editItem.CLAVEDAT"></fiscal-obligation-table>
      </v-tab-item>

      <!-- Usuarios -->
      <v-tab-item v-if="showUsersTab">
        <template>
          <v-layout
            v-for="(user, index) in users"
            class="pa-5"
            :key="index"
            align-center
            justify-center
            row
            fill-height
          >
            <v-flex xs12 sm12 md6 lg6>
              <v-text-field
                class="ml-5"
                v-model="users[index]['name']"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs11 sm11 md5 lg5>
              <v-text-field
                class="ml-5"
                v-model="users[index]['email']"
                label="Email"
                :disabled="true"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1>
              <v-chip v-if="!user.trash" color="primary" outline>
                <v-icon color="primary">mdi-check-outline</v-icon>
                Activo
              </v-chip>
              <v-chip v-if="user.trash" color="error" outline>
                <v-icon color="error">mdi-close-outline</v-icon>
                Desactivado
              </v-chip>
            </v-flex>
          </v-layout>
        </template>
      </v-tab-item>

      <!-- Información adicional -->
      <v-tab-item v-if="showAdditionalDataTab">
        <template>
          <v-layout align-center justify-center column fill-height>
            <v-flex xs12 class="pa-3">
              <v-layout row wrap>
                <v-flex xs12 sm12 md6 lg6 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>¿Cómo remite la documentación? - EMITIDAS</h3>
                    <small class="label-small">
                      Datos de referencia(traspaso Excel, Programa facturación, suele tener
                      operaciones intracomunitarias o no sujetas, etc)
                    </small>
                  </div>
                  <v-textarea
                    outline
                    name="how-send-issued-doc"
                    v-model="additionalData.how_send_issued_doc"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>¿Cómo remite la documentación? - RECIBIDAS</h3>
                    <small class="label-small">
                      Datos de referencia (suele tener operaciones intracomunitarias, inversión del
                      sujeto pasivo,etc)
                    </small>
                  </div>
                  <v-textarea
                    outline
                    name="how-send-received-doc"
                    v-model="additionalData.how_send_received_doc"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>¿Cómo remite la documentación? - BANCOS</h3>
                    <small class="label-small">
                      Datos de referencia (Banco, Usuario y clave, ¿utiliza paypal o stripe?
                      Información sobre préstamos, leasing, etc)
                    </small>
                  </div>
                  <v-textarea
                    outline
                    name="how-send-bank-doc"
                    v-model="additionalData.how_send_bank_doc"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>¿Tiene alquiler?</h3>
                  </div>
                  <v-textarea
                    outline
                    name="has-rent"
                    v-model="additionalData.has_rent"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>¿Tiene trabajadores o profesionales?</h3>
                  </div>
                  <v-textarea
                    outline
                    name="has-workers"
                    v-model="additionalData.has_workers"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg3 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>IVA(PRORRATA): SI/NO</h3>
                  </div>
                  <v-textarea
                    outline
                    name="has-tax-prorate"
                    v-model="additionalData.has_tax_prorate"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg3 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>
                      ¿Porcentaje de deducibilidad en facturas de combustible y en facturas de
                      suministros?
                    </h3>
                  </div>
                  <v-textarea
                    outline
                    name="deductibility-percentage"
                    v-model="additionalData.deductibility_percentage"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 offset-lg3 class="pa-3">
                  <div class="height-50 mb-2">
                    <h3>Otros comentarios</h3>
                  </div>
                  <v-textarea
                    outline
                    name="other-comments"
                    v-model="additionalData.other_comments"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn
                    class="pa-3"
                    style="border-radius: 25px; height: auto; position: fixed; bottom: 25px; right: 25px;"
                    color="primary"
                    @click="submitAdditionalData()"
                  >
                    <v-icon class="white--text mr-2">
                      mdi-check
                    </v-icon>
                    <span class="white--text">GUARDAR</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruAutoForm from '@/components/commons/form/AruAutoForm';
import FiscalObligationTable from './FiscalObligationTable';
export default {
  components: {
    FiscalObligationTable,
    AruAutoForm,
  },
  props: {
    config: {
      type: Object,
    },
    editItem: {
      type: Object,
    },
    editIndex: {
      type: Number,
    },
    noTitle: {
      type: Boolean,
    },
    noCloseButton: {
      type: Boolean,
    },
    title: {
      type: String,
      default: 'Datos fiscales',
    },
    showDataTab: {
      type: Boolean,
      default: true,
    },
    showAddressTab: {
      type: Boolean,
      default: true,
    },
    showBankTab: {
      type: Boolean,
      default: true,
    },
    showJuridicTab: {
      type: Boolean,
      default: true,
    },
    showContractDataTab: {
      type: Boolean,
      default: true,
    },
    showFiscalObligationsTab: {
      type: Boolean,
      default: true,
    },
    showUsersTab: {
      type: Boolean,
      default: true,
    },
    showAdditionalDataTab: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formData: {},
      contractData: {},
      additionalData: {
        how_send_issued_doc: null,
        how_send_received_doc: null,
        how_send_bank_doc: null,
        has_rent: null,
        has_workers: null,
        has_tax_prorate: null,
        deductibility_percentage: null,
        other_comments: null,
      },
      formIae: [],
      tab: 0,
      items: [
        'Información contractual',
        'Datos identificativos',
        'Domicilios',
        'Bancos',
        // 'Actividades',
        'Datos Jurídicos',
      ],

      formDialog: true,
      profile: 'customer',
      dateMenu: false,
      date: null,
      showPassword: false,
      consultants: [],
      role: [],
      roles: ['autonomous', 'pyme'],
      firstLoad: true,
      users: [],
    };
  },
  mounted() {
    if (this.config.customerContract && this.config.customerContract.form) {
      this.tab = 4;
    }

    console.log({
      INSIDECUSTOMERDATAFORM: this.config,
      EDITEDITEM: this.editItem,
    });
    this.formData = this.editItem;
    this.formIae = this.editItem.fiscal_iae;
    this.contractData = this.editItem.customer_contract
      ? this.editItem.customer_contract.contract
      : {};
    this.additionalData =
      this.editItem.customer_additional_data && this.editItem.customer_additional_data.data
        ? this.editItem.customer_additional_data.data
        : this.additionalData;
    this.users = this.editItem.customers.map(item => {
      return item.user;
    });
  },
  computed: {
    tipoContrato() {
      return this.contractData.tipo_contrato ? this.contractData.tipo_contrato : null;
    },
    suplementos() {
      return this.contractData.suplementos_mensuales ? this.contractData.suplementos_mensuales : [];
    },
    otrosSuplementos() {
      return this.contractData.otros_suplementos ? this.contractData.otros_suplementos : [];
    },
    tarifaMensual() {
      return this.contractData.tarifa_mensual ? this.contractData.tarifa_mensual : null;
    },
    totalSuplementos() {
      return this.contractData.total_suplementos ? this.contractData.total_suplementos : null;
    },
    descuentoTarifaMensual() {
      return this.contractData.descuento_tarifa_mensual
        ? this.contractData.descuento_tarifa_mensual
        : null;
    },
  },
  methods: {
    close() {
      this.$emit('closeDialog', true);
    },
    submitContract() {
      apiCtrl
        .post('/customer-contract/clavedat/' + this.editItem.CLAVEDAT, this.contractData)
        .then(res => {
          console.log(res);
          this.$emit('customerContractSaved');
          this.close();
        });
    },
    submitAdditionalData() {
      apiCtrl
        .post('/customer-additional-data/clavedat/' + this.editItem.CLAVEDAT, this.additionalData)
        .then(res => {
          console.log(res);
          this.$emit('customerAdditionalDataSaved');
          this.close();
        });
    },
    calculateSuplementosTotales() {
      if (this.config.customerContract && this.config.customerContract.contract_price) {
        const prices_suplementos = this.config.customerContract.contract_price.suplementos_mensuales
          .options;
        let total = 0;
        this.suplementos.forEach(sup => {
          total = total + Number(prices_suplementos[sup]);
        });

        this.otrosSuplementos.forEach(sup => {
          total = total + Number(sup.cantidad_suplemento);
        });

        this.$set(this.contractData, 'total_suplementos', total);
      }
    },
    calculateTotalTarifa() {
      const total = Number(this.totalSuplementos) + Number(this.tarifaMensual);
      this.$set(this.contractData, 'tarifa_total', total);
    },
    calculateDescuentoTarifaMensual(val) {
      if (val) {
        const total = Number(this.tarifaMensual) - Number(val);
        this.$set(this.contractData, 'tarifa_mensual', total);
      } else {
        const total = Number(this.tarifaMensual) - Number(this.descuentoTarifaMensual);
        this.$set(this.contractData, 'tarifa_mensual', total);
      }
    },
  },
  watch: {
    tipoContrato: function(val, oldVal) {
      console.log('tipocontrato', val, 'prices', this.config.customerContract.contract_price);
      if (val) {
        this.contractData.tarifa_mensual = this.config.customerContract.contract_price.tipo_contrato.options[
          val
        ];
        if (this.firstLoad) {
          this.firstLoad = false;
        } else {
          this.calculateDescuentoTarifaMensual();
        }
      }
    },
    suplementos: function(val, oldVal) {
      if (val) {
        this.calculateSuplementosTotales();
      }
    },
    otrosSuplementos: function(val, oldVal) {
      if (val) {
        this.calculateSuplementosTotales();
      }
    },
    tarifaMensual: function(val, oldVal) {
      if (val) {
        this.calculateTotalTarifa();
      }
    },
    totalSuplementos: function(val, oldVal) {
      if (val) {
        this.calculateTotalTarifa();
      }
    },
    descuentoTarifaMensual: function(val, oldVal) {
      console.log('WATCH DESCUENTO', val);
      if (val) {
        this.calculateDescuentoTarifaMensual(val);
      } else {
        this.calculateDescuentoTarifaMensual(-oldVal);
      }
    },
    editItem: {
      handler: function(val, oldVal) {
        if (this.editItem) {
          console.log({ Watch_Edit_item: this.editItem });
          this.formData = this.editItem;
          console.log({ formData: this.formData });
        }
        if (this.editItem.hasOwnProperty('fiscal_iae')) {
          console.log({ Watch_Edit_item_iae: this.editItem.fiscal_iae });
          this.formIae = this.editItem.fiscal_iae;
          console.log({ formIae: this.formIae });
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.label-small {
  color: #00afa8;
}
.height-50 {
  height: 50px;
}
</style>
